import React from 'react'
import { T } from '@transifex/react'
import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
} from '@lightspeed/design-system-react'

export const SwiperMaintenanceModal = ({
  onClose,
}: {
  onClose: () => void
}) => {
  return (
    <Modal onClose={onClose} size="small">
      <ModalHeader>
        <T
          _str="Unable to process payment right now"
          _context="Integrated payment maintenance modal header"
        />
      </ModalHeader>
      <ModalContent>
        <T
          _str="This payment can't be processed right now. Lightspeed Retail is undergoing required maintenance which will take up to three minutes."
          _context="Integrated payment maintenance modal content"
        />
      </ModalContent>
      <ModalActions>
        <Button onClick={onClose} variant="go">
          <T
            _str="Dismiss"
            _context="Integrated payment maintenance button to dismiss the modal"
          />
        </Button>
      </ModalActions>
    </Modal>
  )
}
